import { Directive, HostListener, Input, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[mmInputTrim]',
    standalone: true,
    exportAs: 'mmInputTrim'
})
export class InputTrimDirective {
    private ngControl = inject(NgControl, { optional: true, self: true });

    @Input() mmInputTrim: boolean | undefined;

    @HostListener('blur', ['$event.target.value']) onBlur(v: string) {
        if (!this.mmInputTrim) {
            return;
        }
        this.onInputBlur(v);
    }

    onInputBlur(inputText: string): void {
        const result = inputText ? inputText.trim() : '';

        if (this.ngControl && this.ngControl.control) {
            this.ngControl.control.patchValue(result);
        }
    }

}
